import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import PatientInfo from './pages/PatientInfo';
import Contact from './pages/Contact';
import Admin from './pages/Admin';
import { Toaster } from './components/ui/sonner';
import BlogList from './pages/BlogList';
import BlogPost from './pages/BlogPost';
import Booking from "./pages/Booking";

function App() {
  return (
    <div className="App">
      <Router>
        <Navbar />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/patient-info" element={<PatientInfo />} />
			    <Route path="/book-appointment" element={<Booking />} />

            <Route path="/contact" element={<Contact />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/blog" element={<BlogList />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
          </Routes>
        </main>
        <Toaster position="top-right" />
      </Router>
    </div>
  );
}

export default App;